// core
import React from "react";
import { SwipeableDrawer } from "@material-ui/core";

import styles from "./SidebarDrawer.module.scss";
import cx from "classnames";
import Icon from "../../../common/components/Icon/Icon";

interface ISidebarDrawer {
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
}

const SidebarDrawer: React.FC<ISidebarDrawer> = (props) => {
    const { isOpen, onClose, onOpen, children } = props;

    return (
        <SwipeableDrawer anchor="left" open={isOpen} onClose={onClose} onOpen={onOpen}>
            <nav className={cx(styles["sidebar"])}>
                {onClose && (
                    <a className={styles["close-button"]} onClick={onClose}>
                        <Icon className={styles["close-icon"]} id="CloseModal" />
                    </a>
                )}

                <div className={cx(styles["content"])}>{children}</div>
            </nav>
        </SwipeableDrawer>
    );
};

export default SidebarDrawer;
